<template>
  <!--dispatch 聊天模块-->
  <div class="chatOut">
    <div class="outBox">
<!--      :style="{ width: width +'px' }"-->
      <div class="inChat">
        <el-popover
          placement="bottom-start"
          :offset="-25"
          width="400"
          trigger="click"
          ref="first_choose"
        >
          <driver-box @chooseAndClose="chooseAndClose"></driver-box>
          <div slot="reference" class="driverImg">
            <img src="../assets/diapatch/addchat@2x.png" alt="" />
          </div>
        </el-popover>
      </div>
      <div class="inChat" v-for="(item, index) in headerChatList" :key="index">
        <el-popover
          placement="bottom-start"
          :offset="-25"
          width="400"
          trigger="click"
          :ref="'popover-' + item.id"
          @show="getHistory(item, index)"
          @after-enter="showScroll(item, index)"
          @after-leave="hidePopover"
        >
          <!--          对话框-->
          <dialog-box
            ref="dialog_box"
            id="historyList"
            class="dialogBox"
            v-on:closeChat="closeChat(index, item)"
            @deleteChat="deleteChat"
            v-loading="chatLoading"
            :message="item"
            :chatHistory="chatHistory"
          >
          </dialog-box>
          <div slot="reference">
            {{ item.firstName }}
            <div class="red" v-if="item.is_point == 1"></div>
          </div>
        </el-popover>
      </div>
    </div>
    <div class="arrow" v-if="showArrow">
      <div class="left" @click="toLeft">
        <img src="../assets/image/left.png" alt="" />
      </div>
      <div class="rights" @click="toRight">
        <img src="../assets/image/right.png" alt="" />
      </div>
    </div>
  </div>
</template>
<script>
import dialogBox from "@/components/dialogBox";
import driverBox from "@/components/driverBox";
import store from "@/store";
import {
  addHeaderDriaverData,
  getChatHistroy,
  getHeaderDriverList,
  getLeftAllDriverList,
  readMes,readMessage
} from "@/api/chatBox";
import EventBus from "@/ws/eventBus";
export default {
  name: "chatBox",
  components: {
    dialogBox,
    driverBox
  },
  data() {
    return {
      hiddenList: [],
      showArrow: false,
      width: "",
      a: 0,
      b: 0,
      resoult: 0,
      first: [],
      chatHistory: [],
      chatLoading: false,
      headerChatList: [],
      topPage: 1,
      preSrollHeight: 0,
      clickIndex: 0,
      curerntChatOpen: {},
    };
  },
  created() {
    //获取聊天列表的数据
    this.getHeaderDriverData();
    //获取屏幕宽度 宽度除以单位 大于list 的长度 则显示左右箭头
    let width = window.screen.width-610 //- 550-20;
    this.width = width;
    // let chatWidth = width / 72;
    // if (Math.floor(chatWidth) < this.headerChatList?.length) {
    //   this.showArrow = true;
    //   //截取 超出部分的数组 作为后续滚动的数组
    //   this.hiddenList = this.headerChatList.splice(
    //     Math.floor(chatWidth),
    //     this.headerChatList.length - 1
    //   );
    // }else{
    // }
    EventBus.$on("updateChatData", (a) => {
      this.updateChatDriverDta(a);
    });

    EventBus.$on("updateChatDataAdmin", (a) => {
      this.updateChatDriverAdminData(a);
    });
  },
  destroyed() {
    EventBus.$off("updateChatData");
    EventBus.$off("updateChatDataAdmin");
  },
  methods: {
    setDataReset(){
      this.a = 0
      this.b = 0
      this.resoult = 0
      this.hiddenList = []
      this.first = []
      this.showArrow = false
    },
    showHeaderChatArrow(){
      // this.width = 500+'px'
      let chatWidth = this.width / 72;

      // console.log('chatwidth:',chatWidth,this.headerChatList)

      if (Math.floor(chatWidth) <= this.headerChatList?.length) {
        // console.log('11111.',Math.floor(chatWidth),this.headerChatList.length)

        this.showArrow = true;
        //截取 超出部分的数组 作为后续滚动的数组
        this.hiddenList = this.headerChatList.splice(
          Math.floor(chatWidth-1),
          this.headerChatList.length - 1
        );
        // console.log('=hiddenList===',this.hiddenList)
      }else{
        // console.log('没有超过--',Math.floor(chatWidth),this.headerChatList.length)
      }
    },



    updateChatDriverAdminData(a) {
      // console.log("==admin发出的新信息==", a);
      // console.log("--当前打开的窗口司机信息--", this.curerntChatOpen);
      //判断打开的司机是不是和WS发送过来的里面的司机是否一致
      if (
        a.receiver_id != undefined &&
        a.receiver_id == this.curerntChatOpen.id
      ) {
        this.chatHistory.push({
          receiver_id: a.receiver_id,
          receiver_type: a.receiver_type,
          sender_id: a.sender_id,
          sender_type: a.sender_type,
          time: a.time,
          msg_id: a.msg_id,
          content:
            a.msg_type == 3
              ? process.env.VUE_APP_BASE_URL + a.content
              : a.content,
          msg_type: a.msg_type, //发送类型 1文字 2图片 3语音
          audit_time: a.audit_time,
          is_player: 0,
          id: a.msg_id,
        });
        this.$nextTick(() => {
          this.$refs.dialog_box[this.clickIndex].scrollToBottom();
        });
      }
    },
    updateChatDriverDta(a) {
      // console.log("---新消息---", a);
      if (this.$refs[`popover-` + a.sender_id]) {
          // console.log('--???--',this.$refs[`popover-` + a.sender_id])
        if(this.$refs[`popover-` + a.sender_id].length == 0){
          this.headerChatList = store.state.header_driver;
          this.$forceUpdate();
          return
        }
        if (this.$refs[`popover-` + a.sender_id][0].showPopper) {
          // console.log('--当前聊天窗口已经打开--初始数据不是新添加的--当前是聊天列表详情--消息叠加--')

          this.chatHistory.push({
            receiver_id: a.receiver_id,
            receiver_type: a.receiver_type,
            sender_id: a.sender_id,
            sender_type: a.sender_type,
            time: a.time,
            msg_id: a.msg_id,
            content:
              a.msg_type == 3
                ? process.env.VUE_APP_BASE_URL + a.content
                : a.content,
            msg_type: a.msg_type, //发送类型 1文字 2图片 3语音
            audit_time: a.audit_time,
            is_player: 0,
            id: a.msg_id,
          });
          this.$nextTick(() => {
            // console.log(this.clickIndex);
            this.$refs.dialog_box[this.clickIndex].scrollToBottom();
          });
          this.headerChatList.forEach((v) => {
            if (v.id == a.sender_id) {
              v.is_point = 0
            }
          });
          //弹框打开的情况下，如果接收到消息 将消息变成已读
          let arr = [];
          arr.push(a.msg_id);
          this.readMsg(a.msg_id);//修改已读消息
        } else {
          // console.log('--当前列表中已存在的司机有新消息--')
          let driver_id = store.state.click_driver.id;
          // this.$refs[`popover-` + driver_id][0].showPopper = true
          this.headerChatList = store.state.header_driver;
          this.$forceUpdate();
        }
      }else{
        // console.log('---当前列表中没有新消息的司机--')
        // let driver_id = store.state.click_driver.id;
        // console.log('--driver_id--',driver_id)
        // this.$refs[`popover-` + driver_id][0].showPopper = true

        this.headerChatList = store.state.header_driver;
        this.$forceUpdate();
      }
      // console.log(this.chatHistory, "chatHistory");
    },
    chooseAndClose(e) {
      this.$refs.first_choose.doClose();
      //todo 这里需要判断一下 当前的列表中是否已经存在该司机

      // console.log('eeee-',e)

      let result = this.headerChatList.some((v) => v.worker_id == e.worker_id);
      if (!result) {
        addHeaderDriaverData({
          id: e.id,
        }).then((res) => {
          if (res.code == 200) {
            this.headerChatList.unshift(e);
            // console.log('tianjia---',this.headerChatList,this.headerChatList.length)
            this.setDataReset()
            this.showHeaderChatArrow()
            store.commit("updataHeaderDriver", this.headerChatList);

          } else {
            this.$message({
              type: "error",
              message: res.msg,
            });
          }
        });
      } else {
        alert('聊天列表中已经有该司机啦！')
      }
      // console.log(this.headerChatList,'headerChatList')
      // store.commit("updataHeaderDriver", this.headerChatList);
    },
    //获取头部聊天司机列表
    getHeaderDriverData() {
      getHeaderDriverList()
        .then((res) => {
          if (res.code == 200) {
            let arr = res.data;
            arr.forEach((i, v) => {
              i.firstName =i.name.charAt(0).toUpperCase() + i.name.charAt(1).toUpperCase();
              // if (i.read_msg == 1) {
                //红点显示已做更改 2023年8月5日
              if (i.is_point == 1) {
                res.data.splice(v, 1);
                res.data.unshift(i);
              }
            });
            store.commit("updataHeaderDriver", res.data);
            this.headerChatList = res.data;
            // console.log('--获取头部聊天司机列表headerChatList--',this.headerChatList);

            this.showHeaderChatArrow()
          }
        })
        .catch((err) => {});
    },
    readMsg(a) {
      readMessage({
        msg_id: a,
      }).then((res) => {});
    },
    //隐藏时 将存入vuex 的数据置为-1
    hidePopover() {
      store.commit("chagneDriverId");
    },
    //获取聊天历史
    getHistory(i, v) {
      this.curerntChatOpen = i;

      this.chatLoading = true;
      this.headerChatList.forEach((it) => {
        if (it.id == i.id) {
          // i.read_msg = -1;
          i.is_point = -1;
        }
      });
      this.topPage = 1;
      getChatHistroy({
        receiver_id: i.id,
        receiver_type: i.type, //接收人类型 0管理员 1门店 2派单员 3司机
        limit: 20,
        page: this.topPage,
      }).then((res) => {
        if (res.code == 200) {
          this.chatLoading = false;
          this.chatHistory = res.data;
          this.chatHistory.forEach((v) => {
            if (v.msg_type == 3) {
              // v.content = 'https://escroud.rapidi.ca/'+ v.content
              v.content = process.env.VUE_APP_BASE_URL + v.content;
            }
          });
          setTimeout(() => {
            this.$refs.dialog_box[v].scrollToBottom();
          }, 100);
        }
      });
    },
    showScroll(i, v) {
      this.clickIndex = v;
      i.fixed_index = v;
      //将点击的司机 存储再vuex中 在有弹框打开的情况下能手动打开弹框
      store.commit("saveDriverId", i);
    },
    //向左缩进
    toLeft() {
      if (this.first.length == 0) {
        this.$message({
          type:'warning',
          message:'到头啦'
        })
      } else {
        if (this.resoult > -1) {
          this.headerChatList.unshift(this.first[this.resoult]);
          this.first.splice(this.resoult,1)
          this.resoult--;
          this.a--
        } else {
          this.$message({
            type:'warning',
            message:'已经是第一个啦'
          })
        }
      }
    },
    //向右边缩进
    toRight() {

      if (this.a < this.hiddenList.length) {
        // console.log('---this.a--',this.a,this.hiddenList.length)

        this.first.push(this.headerChatList[0]);

        this.headerChatList.splice(0, 1);
        this.headerChatList.push(this.hiddenList[this.a]);
        this.a = ++this.a;
        this.resoult = this.first.length - 1;
      } else {
        this.$message({
          type: "warning",
          message: "到头啦",
        });
      }

      // console.log('--this.first--',this.first,this.resoult)
      // console.log('this.aaaaaaaaaaa--',this.a,this.hiddenList.length)

    },
    closeChat(index, item) {
      this.$refs[`popover-` + item.id][0].doClose();
    },
    deleteChat(a) {
      //this.headerChatList objs.splice(objs.findIndex(item=>item.id==2),1)
      // console.log(a, "aaaa");
      this.headerChatList.splice(
        this.headerChatList.findIndex((v) => v.worker_id == a.worker_id),
        1
      );
      this.setDataReset()
      this.getHeaderDriverData()
    },
  },
};
</script>

<style scoped lang="less">
/deep/.el-header {
  height: 72px !important;
}
/deep/.el-loading-mask {
  border-radius: 8px;
}
.dialogBox {
  height: 100%;
}
.chatOut {
  width: 100%;
  height: 100%;
  display: flex;
  .outBox {
    width: calc(100vw - 610px);
    display: flex;
    height: 50px;
    flex-wrap: wrap;
    overflow-y: hidden;
    margin-left: 20px;
    margin-top: -4px;
    .inChat {
      cursor: pointer;
      font-weight: 400;
      font-size: 14px;
      color: #1f2d42;
      margin: 0 12px;
      width: 48px;
      height: 48px;
      line-height: 48px;
      border-radius: 50%;
      background: #f5f6fb;
      border: 1px solid #e0e0e0;
      position: relative;
      .red {
        position: absolute;
        top: 0;
        right: 0;
        width: 12px;
        height: 12px;
        border-radius: 50%;
        background: #e95646;
      }
      .driverImg {
        img {
          width: 24px;
          height: 20px;
          vertical-align: middle;
        }
      }
    }
  }
  .arrow {
    display: flex;
    align-items:center;
    .left {
      margin-right: 16px;
      cursor: pointer;
    }
    .rights {
      cursor: pointer;
    }
  }
}
</style>
